export interface PeopleFeedbackState {
    live?: PeopleFeedback;
    cache?: PeopleFeedback;
    directory?: PeopleFeedback;
}

export interface PeopleFeedback {
    CorrelationId: string;
    TimeStamp: string;
    QueryString: string;
    SuggestionSource: string;
    RawResponse: string;
}

export function createPeopleFeedback(): PeopleFeedback {
    return {
        CorrelationId: '',
        TimeStamp: '',
        QueryString: '',
        SuggestionSource: '',
        RawResponse: '',
    };
}
